import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { formatDate, formatDateToISOWeek } from '@util/date-util'

type Props = {
  dueDate?: string
}

export const Due = ({ dueDate }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
      }}
    >
      {formatDate(dueDate)}

      <Typography variant="caption">{formatDateToISOWeek(dueDate)}</Typography>
    </Box>
  )
}
